import { COLLECTION_ROLES } from '@/model/AppConstants';
import PermissionType from './PermissionType';
import Role from './Role';
import RoleType from './RoleType';

export default function loadUserManagementObjects(store: any) {

  const superadminPayload = new Role({ ...RoleType.superAdminRoleType });
  superadminPayload.permissions.push(
    { ...PermissionType.createPost },
    { ...PermissionType.deleteUser },
    { ...PermissionType.editUser },
    { ...PermissionType.viewUser },
    { ...PermissionType.createPost },
    { ...PermissionType.deletePost },
    { ...PermissionType.revokeUser },
    { ...PermissionType.editPost },
    { ...PermissionType.viewPost },
    { ...PermissionType.blockUser },
    { ...PermissionType.blockPost },
  );

  store.dispatch('loadRole', {
    collection: COLLECTION_ROLES,
    payload: superadminPayload,
  });
  const adminPayload = new Role({ ...RoleType.adminRoleType });
  adminPayload.permissions.push(
    { ...PermissionType.createPost },
    { ...PermissionType.viewUser },
    { ...PermissionType.createPost },
    { ...PermissionType.deletePost },
    { ...PermissionType.editPost },
    { ...PermissionType.viewPost },
    { ...PermissionType.blockPost },
  );

  store.dispatch('loadRole', {
    collection: COLLECTION_ROLES,
    payload: adminPayload,
  });

  const userPayload = new Role({ ...RoleType.userRoleType });
  userPayload.permissions.push(
    { ...PermissionType.createPost },
    { ...PermissionType.deletePost },
    { ...PermissionType.editPost },
    { ...PermissionType.viewPost },
  );

  store.dispatch('loadRole', {
    collection: COLLECTION_ROLES,
    payload: userPayload,
  });
}
